module.exports = __webpack_public_path__ + "img/iron.be5030ca.webp";